// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"881":"d0075f58","891":"9a3f1a14"}[chunkId] + ".css";
};